<template>
  <div class="feature-gated-stamp">
    <i class="ddi ddi-warning" />
    Your account plan does not have this feature enabled. If you're interested in this feature, 
    <a href="https://www.donedone.com/help-center" target="_blank" class="just-a-link">let us know</a>.
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FeatureGatedStamp',
})
</script>

<style lang="scss">
.feature-gated-stamp {
  text-align: center;
  padding: 12px;
  background-color: $color--pink-60;
  border-radius: 8px;
  @include lettering--p-sm--no-color;
  color: $color--white;

  * {
    color: $color--white !important;
  }
}
</style>
